<div [style]="injectClass" *ngIf="contacts && contacts.length">

<h3 class="page-module-header" *ngIf="contacts && contacts.length && header && header.length">{{ header }}</h3>

<div class="row" *ngIf="contacts && contacts.length">
  <div *ngFor="let contact of contacts" class="col-md-6 col-lg-4 contact">
    <div class="label">{{ contact.label }}</div>
    <div>{{ contact.name }}</div>
    <div>{{ contact.company }}</div>
    <div>
      <a [href]="'mailto:' + contact.primary_email">
        {{ contact.primary_email }}
      </a>
    </div>
    <div *ngIf="contact.url">
      <a [href]="contact.url" target="_blank">{{ contact.url }}</a>
    </div>
  </div>
</div>
</div>